export var InstanceVersionUpdatePolicy;
(function (InstanceVersionUpdatePolicy) {
    InstanceVersionUpdatePolicy["Manual"] = "manual";
    InstanceVersionUpdatePolicy["Stable"] = "stable";
    InstanceVersionUpdatePolicy["Beta"] = "beta";
})(InstanceVersionUpdatePolicy || (InstanceVersionUpdatePolicy = {}));
export var ModuleInstanceType;
(function (ModuleInstanceType) {
    ModuleInstanceType["Connection"] = "connection";
    // Surface = 'surface', // Future
})(ModuleInstanceType || (ModuleInstanceType = {}));
//# sourceMappingURL=Instance.js.map